export default class MonitoringColumnsRowVariant {
  get(row) {
    if (row.statusCode.includes('SUCCESS')) {
      return 'success'
    }
    if (row.statusCode.includes('ERROR')) {
      return 'error'
    }
    if (row.statusCode.includes('PENDING')) {
      return 'warning'
    }
    return 'summary'
  }
}
